import { render, staticRenderFns } from "./PatientBanner.vue?vue&type=template&id=3bf9ff04&scoped=true&"
import script from "./PatientBanner.vue?vue&type=script&lang=js&"
export * from "./PatientBanner.vue?vue&type=script&lang=js&"
import style0 from "./PatientBanner.vue?vue&type=style&index=0&id=3bf9ff04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9ff04",
  null
  
)

export default component.exports